//==================================================================//
//======================= IMPORTS API ==============================//
//==================================================================//

import ERP from "../ERP.mjs";
import View from "../View.mjs";
import Schema from "../Schema.mjs";

//==================================================================//
//===================== IMPORTS SERVICES ===========================//
//==================================================================//

import ColaboradorService from "./ColaboradorService";
import OrdemDePagamentoDespesasService from "./OrdemDePagamentoDespesasService";
import OrdemDePagamentoParcelasService from "./OrdemDePagamentoParcelasService";
import OrdemDePagamentoAprovadoresService from "./OrdemDePagamentoAprovadoresService";

//==================================================================//
//======================= IMPORT UTILS =============================//
//==================================================================//

import UtilArray from "@/utils/UtilArray.mjs";
import UtilSequence from "@/utils/UtilSequence.mjs";

//==================================================================//
//====================== IMPORT STORES =============================//
//==================================================================//

import useUsuarioStore from "../stores/UsuarioStore";

//==================================================================//
//===================== ADMIN ID & OWNER ===========================//
//==================================================================//

const ADMIN_OWNER = "23e308ed-4f67-4394-9a77-7228d2992dc3";

//==================================================================//
//========================= METHODS ================================//
//==================================================================//

export default {

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async pegaViewOrdemDePagamento(){

        let usuarioStore = useUsuarioStore();
        let ordensDePagamento;

        try{

            //==================================================================//
            //==================== Pega Ordens de Pagamento ====================//
            //==================================================================//

            ordensDePagamento = await ERP.getManyWithView(View.ORDEM_DE_PAGAMENTO,[
                {
                    name: "owner",
                    dataType: "String",
                    value: usuarioStore.usuario.id
                },
            ]);

        }catch(e){

            console.log(e);
            return ordensDePagamento;

        }

        return ordensDePagamento;

    },

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async pegaViewOrdemDePagamentoRequisitantes(){

        let ordemDePagamentoRequisitantes;

        try{

            //==================================================================//
            //============== Pega Ordem de Pagamento Requisitantes =============//
            //==================================================================//

            ordemDePagamentoRequisitantes = await ERP.getManyWithView(View.ORDEM_DE_PAGAMENTO_REQUISITANTES);

        }catch(e){

            console.log(e);
            return ordemDePagamentoRequisitantes;

        }

        return ordemDePagamentoRequisitantes;

    },

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async pegaViewOrdemDePagamentoCredorColaboradores(){

        let ordemDePagamentoCredorColaboradores;

        try{

            //==================================================================//
            //========== Pega Ordem de Pagamento Credor Colaboradores ==========//
            //==================================================================//

            ordemDePagamentoCredorColaboradores = await ERP.getManyWithView(View.ORDEM_DE_PAGAMENTO_CREDOR_COLABORADORES);

        }catch(e){

            console.log(e);
            return ordemDePagamentoCredorColaboradores;

        }

        return ordemDePagamentoCredorColaboradores;

    },

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async pegaViewOrdemDePagamentoCredorFornecedores(){

        let ordemDePagamentoCredorFornecedores;

        try{

            //==================================================================//
            //=========== Pega Ordem de Pagamento Credor Fornecedores ==========//
            //==================================================================//

            ordemDePagamentoCredorFornecedores = await ERP.getManyWithView(View.ORDEM_DE_PAGAMENTO_CREDOR_FORNECEDORES);

        }catch(e){

            console.log(e);
            return ordemDePagamentoCredorFornecedores;

        }

        return ordemDePagamentoCredorFornecedores;

    },

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async pegaViewOrdemDePagamentoDespesas(){

        let ordemDePagamentoDespesas;

        try{

            //==================================================================//
            //================ Pega Ordem de Pagamento Despesas ================//
            //==================================================================//

            ordemDePagamentoDespesas = await ERP.getManyWithView(View.ORDEM_DE_PAGAMENTO_DESPESAS);

        }catch(e){

            console.log(e);
            return ordemDePagamentoDespesas;

        }

        return ordemDePagamentoDespesas;

    },

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async pegaViewOrdemDePagamentoJobs(){

        let ordemDePagamentoJobs;

        try{

            //==================================================================//
            //================== Pega Ordem de Pagamento Jobs ==================//
            //==================================================================//

            ordemDePagamentoJobs = await ERP.getManyWithView(View.ORDEM_DE_PAGAMENTO_JOBS);

        }catch(e){

            console.log(e);
            return ordemDePagamentoJobs;

        }

        return ordemDePagamentoJobs;

    },

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async criaOrdemDePagamentoPai(ordemDePagamentoValores = {}){

        let usuarioStore = useUsuarioStore();
        let ordemDePagamento;

        try{

            //==================================================================//
            //============== CRIA DESPESAS DA ORDEM DE PAGAMENTO ===============//
            //==================================================================//

            let despesasValores = ordemDePagamentoValores?.despesas || [];

            let ordemDePagamentoDespesas = await OrdemDePagamentoDespesasService.criaDespesas(despesasValores);
            if(ordemDePagamentoDespesas?.status != 200){
                throw ordemDePagamentoDespesas;
            }

            let despesasIDs = ordemDePagamentoDespesas?.data?.map(({ id }) => id) || [];

            //==================================================================//
            //============== CRIA PARCELAS DA ORDEM DE PAGAMENTO ===============//
            //==================================================================//

            let parcelasValores = ordemDePagamentoValores?.parcelas || [];

            let ordemDePagamentoParcelas = await OrdemDePagamentoParcelasService.criaParcelas(parcelasValores);
            if(ordemDePagamentoParcelas?.status != 200){
                throw ordemDePagamentoParcelas;
            }

            let parcelasIDs = ordemDePagamentoParcelas?.data?.map(({ id }) => id) || [];

            //==================================================================//
            //==================== CRIAR ORDEM DE PAGAMENTO ====================//
            //==================================================================//

            // Como o Usuário Logado é o Emitente, então eu passo o Owner do Usuário Logado.
            const USER_OWNER = usuarioStore?.usuario?.id || "";

            let owners = UtilArray.unique([ADMIN_OWNER, USER_OWNER]); 

            ordemDePagamentoValores = {
                status: "Elaboração",
                hierarquia: "Pai",
                tipo: ordemDePagamentoValores?.tipo || "",
                emitente: ordemDePagamentoValores.emitente || "",
                requisitante: ordemDePagamentoValores?.requisitante || "",
                notaFiscal: ordemDePagamentoValores?.notaFiscal || "",
                tipoCredor: ordemDePagamentoValores?.tipoCredor || "",
                credorColaborador: ordemDePagamentoValores?.credorColaborador || "",
                credorFornecedor: ordemDePagamentoValores?.credorFornecedor || "",
                formaDePagamento: ordemDePagamentoValores?.formaDePagamento || "",
                justificativa: ordemDePagamentoValores?.justificativa || "",
                valorTotal: ordemDePagamentoValores?.valorTotal || 0,
                recorrencia: ordemDePagamentoValores?.recorrencia || false,
                recorrenciaQuantidadeTotal: ordemDePagamentoValores?.recorrenciaQuantidadeTotal || 0,
                recorrenciaQuantidadeAtual: 0,
                dataCriacao: ordemDePagamentoValores?.dataCriacao || "",
                dataPrevisaoPagamento: ordemDePagamentoValores?.dataPrevisaoPagamento || "",
                job: ordemDePagamentoValores?.job || "",
                ordemDeServico: ordemDePagamentoValores?.ordemDeServico || "",
                despesas: despesasIDs || [],
                parcelas: parcelasIDs || [],
                owners: owners || []
            }

            //==================================================================//
            //==================== Cria Ordem de Pagamento =====================//
            //==================================================================//

            ordemDePagamento = await ERP.postOne(Schema.ORDEM_DE_PAGAMENTO, ordemDePagamentoValores);
            if(ordemDePagamento.status != 200){
                throw ordemDePagamento;
            }

            console.log(ordemDePagamento);

        }catch(e){

            console.log(e);
            return ordemDePagamento;

        }

        return ordemDePagamento;

    },

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    // NÃO USAR AINDA, ISSO É APENAS UM COPIA COLA DE REFERENCIA.
    // ESTÁ SEMI-PREPARADA PARA USO, POREM ALTERAR E AJEITAR A CRITÉRIO ANTES.

    async criaOrdemDePagamentoFilho(ordemDePagamentoValores = {}){

        let usuarioStore = useUsuarioStore();
        let ordemDePagamento;

        try{

            //==================================================================//
            //============== CRIA DESPESAS DA ORDEM DE PAGAMENTO ===============//
            //==================================================================//

            let despesasValores = ordemDePagamentoValores?.despesas || [];

            let ordemDePagamentoDespesas = await OrdemDePagamentoDespesasService.criaDespesas(despesasValores);
            if(ordemDePagamentoDespesas?.status != 200){
                throw ordemDePagamentoDespesas;
            }

            let despesasIDs = ordemDePagamentoDespesas?.data?.map(({ id }) => id) || [];

            //==================================================================//
            //============== CRIA PARCELAS DA ORDEM DE PAGAMENTO ==============//
            //==================================================================//

            let parcelasValores = ordemDePagamentoValores?.parcelas || [];

            let ordemDePagamentoParcelas = await OrdemDePagamentoParcelasService.criaParcelas(parcelasValores);
            if(ordemDePagamentoParcelas?.status != 200){
                throw ordemDePagamentoParcelas;
            }

            let parcelasIDs = ordemDePagamentoParcelas?.data?.map(({ id }) => id) || [];

            //==================================================================//
            //==================== CRIAR ORDEM DE PAGAMENTO ====================//
            //==================================================================//

            // Como o Usuário Logado é o Emitente, então eu passo o Owner do Usuário Logado.
            const USER_OWNER = usuarioStore?.usuario?.id || "";

            let owners = UtilArray.unique([ADMIN_OWNER, USER_OWNER]); 

            ordemDePagamentoValores = {
                status: "Elaboração",
                hierarquia: "Filho",
                tipo: ordemDePagamentoValores?.tipo || "",
                ordemDePagamentoPai: ordemDePagamentoValores?.id || "",
                emitente: ordemDePagamentoValores.emitente || "",
                requisitante: ordemDePagamentoValores?.requisitante || "",
                notaFiscal: ordemDePagamentoValores?.notaFiscal || "",
                tipoCredor: ordemDePagamentoValores?.tipoCredor || "",
                credorColaborador: ordemDePagamentoValores?.credorColaborador || "",
                credorFornecedor: ordemDePagamentoValores?.credorFornecedor || "",
                formaDePagamento: ordemDePagamentoValores?.formaDePagamento || "",
                justificativa: ordemDePagamentoValores?.justificativa || "",
                valorTotal: ordemDePagamentoValores?.valorTotal || 0,
                recorrencia: ordemDePagamentoValores?.recorrencia || false,
                recorrenciaQuantidadeTotal: ordemDePagamentoValores?.recorrenciaQuantidadeTotal || 0,
                recorrenciaQuantidadeAtual: 0,
                dataCriacao: ordemDePagamentoValores?.dataCriacao || "",
                dataPrevisaoPagamento: ordemDePagamentoValores?.dataPrevisaoPagamento || "",
                job: ordemDePagamentoValores?.job || "",
                ordemDeServico: ordemDePagamentoValores?.ordemDeServico || "",
                despesas: despesasIDs || [],
                parcelas: parcelasIDs || [],
                owners: owners || []
            }

            //==================================================================//
            //==================== Cria Ordem de Pagamento =====================//
            //==================================================================//

            ordemDePagamento = await ERP.postOne(Schema.ORDEM_DE_PAGAMENTO, ordemDePagamentoValores);
            if(ordemDePagamento.status != 200){
                throw ordemDePagamento;
            }

            console.log(ordemDePagamento);

        }catch(e){

            console.log(e);
            return ordemDePagamento;

        }

        return ordemDePagamento;

    },

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async editarOrdemDePagamento(ordemDePagamentoValores = {}){

        let usuarioStore = useUsuarioStore();
        let ordemDePagamento;

        try{

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //================= PEGA ORDEM DE PAGAMENTO ========================//
            //==================================================================//

            let ordemDePagamentoID = ordemDePagamentoValores?.id;

            ordemDePagamento = await ERP.getOneById(Schema.ORDEM_DE_PAGAMENTO, ordemDePagamentoID);
            if(ordemDePagamento?.status != 200){
                throw ordemDePagamento;
            }

            let ordemDePagamentoOwners = ordemDePagamento?.data?.owners?.reduce((acc,owner)=>{

                acc.push(owner?.userId || "");

                return acc;

            },[]);
            
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //===================== Gerencia Despesas =========================//
            //==================================================================//

            const gerenciaDespesas = async (despesas = []) => {

                let despesasGerenciadas = await UtilSequence.each({
                    list: despesas,
                    callback: async (despesa = {}) => {

                        //==================================================================//
                        //===================== Remove Despesa da Ordem ====================//
                        //==================================================================//

                        if(despesa?.remover === true){
                            return;
                        }

                        //==================================================================//
                        //=================== PREPARA VALORES DA DESPESA ===================//
                        //==================================================================//

                        let despesaValores = {
                            id: despesa?.id || "",
                            despesa: despesa?.despesa || "",
                            dataCriacao: despesa?.dataCriacao || "",
                            dataDaDespesa: despesa?.dataDaDespesa || "",
                            valor: despesa?.valor || 0,
                            veiculoTipo: despesa?.veiculoTipo || "Nenhum",
                            veiculoPlaca: despesa?.veiculoPlaca || "",
                            veiculoKMInicial: despesa?.veiculoKMInicial || 0,
                            veiculoKMFinal: despesa?.veiculoKMFinal || 0,
                            observacao: despesa?.observacao ?? "",
                            anexos: despesa?.anexos ?? [],
                        };

                        //==================================================================//
                        //======================= Cria Despesa =============================//
                        //==================================================================//

                        if(despesa?.rascunho === true){

                            let despesaCriada = await OrdemDePagamentoDespesasService.criaDespesa(despesaValores);
                            if(despesaCriada?.status != 200){
                                throw despesaCriada;
                            }

                            return { id: despesaCriada?.data?.id || "" };

                        }

                        //==================================================================//
                        //====================== Altera Despesa ============================//
                        //==================================================================//

                        let despesaAlterada = await OrdemDePagamentoDespesasService.alteraDespesa(despesaValores);
                        if(despesaAlterada?.status != 200){
                            throw despesaAlterada;
                        }

                        return { id: despesaValores?.id || "" };

                    },

                });

                return despesasGerenciadas?.map(({ id }) => id) || [];

            };

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //===================== Gerencia Parcelas =========================//
            //==================================================================//

            const gerenciaParcelas = async (parcelas = []) => {

                let parcelasGerenciadas = await UtilSequence.each({
                    list: parcelas,
                    callback: async (parcela = {}) => {

                        //==================================================================//
                        //===================== Remove Parcela da Ordem ====================//
                        //==================================================================//

                        if(parcela?.remover === true){
                            return;
                        }

                        //==================================================================//
                        //=================== PREPARA VALORES DA PARCELA ===================//
                        //==================================================================//

                        let parcelaValores = {
                            id: parcela?.id || "",
                            descricao: parcela?.descricao || "",
                            dataCriacao: parcela?.dataCriacao || "",
                            dataDoPagamento: parcela?.dataDoPagamento || "",
                            valor: parcela?.valor || 0,
                        };

                        //==================================================================//
                        //======================= Cria Parcela =============================//
                        //==================================================================//

                        if(parcela?.rascunho === true){

                            let parcelaCriada = await OrdemDePagamentoParcelasService.criaParcela(parcelaValores);
                            if(parcelaCriada?.status != 200){
                                throw parcelaCriada;
                            }

                            return { id: parcelaCriada?.data?.id || "" };

                        }

                        //==================================================================//
                        //====================== Altera Parcela ============================//
                        //==================================================================//

                        let parcelaAlterada = await OrdemDePagamentoParcelasService.alteraParcela(parcelaValores);
                        if(parcelaAlterada?.status != 200){
                            throw parcelaAlterada;
                        }

                        return { id: parcelaValores?.id || "" };

                    },
                });

                return parcelasGerenciadas?.map(({ id }) => id) || [];

            };

            //==================================================================//
            //=================== EXECUTA GERENCIAMENTO ========================//
            //==================================================================//

            let despesasIDs = await gerenciaDespesas(ordemDePagamentoValores?.despesas || []);
            let parcelasIDs = await gerenciaParcelas(ordemDePagamentoValores?.parcelas || []);

            //==================================================================//
            //=================== EDITAR ORDEM DE PAGAMENTO ====================//
            //==================================================================//

            // Como o Usuário Logado é o Emitente, então eu passo o Owner do Usuário Logado.
            const USER_OWNER = usuarioStore?.usuario?.id || "";

            let owners = UtilArray.unique([ADMIN_OWNER, USER_OWNER, ...ordemDePagamentoOwners]);

            ordemDePagamentoValores = {
                id: ordemDePagamentoValores?.id || "",
                tipo: ordemDePagamentoValores?.tipo || "",
                emitente: ordemDePagamentoValores?.emitente || "",
                requisitante: ordemDePagamentoValores?.requisitante || "",
                notaFiscal: ordemDePagamentoValores?.notaFiscal || "",
                tipoCredor: ordemDePagamentoValores?.tipoCredor || "",
                credorColaborador: ordemDePagamentoValores?.credorColaborador || "",
                credorFornecedor: ordemDePagamentoValores?.credorFornecedor || "",
                formaDePagamento: ordemDePagamentoValores?.formaDePagamento || "",
                justificativa: ordemDePagamentoValores?.justificativa || "",
                valorTotal: ordemDePagamentoValores?.valorTotal || 0,
                recorrencia: ordemDePagamentoValores?.recorrencia || false,
                recorrenciaQuantidadeTotal: ordemDePagamentoValores?.recorrenciaQuantidadeTotal || 0,
                recorrenciaQuantidadeAtual: 0,
                dataCriacao: ordemDePagamentoValores?.dataCriacao || "",
                dataPrevisaoPagamento: ordemDePagamentoValores?.dataPrevisaoPagamento || "",
                job: ordemDePagamentoValores?.job || "",
                ordemDeServico: ordemDePagamentoValores?.ordemDeServico || "",
                despesas: despesasIDs || [],
                parcelas: parcelasIDs || [],
                owners: owners || []
            }

            //==================================================================//
            //================== Altera Ordem de Pagamento =====================//
            //==================================================================//

            ordemDePagamento = await ERP.patchOne(Schema.ORDEM_DE_PAGAMENTO, ordemDePagamentoValores);
            if(ordemDePagamento.status != 200){
                throw ordemDePagamento;
            }

            console.log(ordemDePagamento);

        }catch(e){

            console.log(e);
            return ordemDePagamento;

        }

        return ordemDePagamento;

    },

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async enviarOrdemDePagamentoParaAprovacao(ordemDePagamentoValores = {}){

        let ordemDePagamento;

        try{

            //==================================================================//
            //================= PEGA ORDEM DE PAGAMENTO ========================//
            //==================================================================//

            let ordemDePagamentoID = ordemDePagamentoValores?.id;

            ordemDePagamento = await ERP.getOneById(Schema.ORDEM_DE_PAGAMENTO, ordemDePagamentoID);
            if(ordemDePagamento?.status != 200){
                throw ordemDePagamento;
            }

            //==================================================================//
            //==================== CRIAR APROVADORES ===========================//
            //==================================================================//

            let ordemDePagamentoAprovadores = await OrdemDePagamentoAprovadoresService.criarAprovadoresParaOrdemDePagamento(ordemDePagamentoID);
            if(ordemDePagamentoAprovadores.status != 200){
                throw ordemDePagamentoAprovadores;
            }

            let aprovadoresIDs = ordemDePagamentoAprovadores?.data?.map(({ id }) => id) || [];

            //==================================================================//
            //===================== PEGA OWNER DO EMITENTE =====================//
            //==================================================================//

            let emitenteID = ordemDePagamento?.data?.emitente;

            let emitenteUsuario = await ColaboradorService.pegaColaboradorUsuario(emitenteID);
            if(emitenteUsuario?.status != 200){
                throw emitenteUsuario;
            }

            let emitenteOwner = emitenteUsuario?.data;

            //==================================================================//
            //================= PEGA OWNERS DOS REQUISITANTES ==================//
            //==================================================================//

            let requisitantesIDs = ordemDePagamentoAprovadores?.data?.reduce((acc, aprovador = {}) => {

                if(aprovador?.aprovadorTipo === "Requisitante"){

                    acc.push(aprovador?.aprovador);

                }

                return acc;

            },[]);

            let requisitantesUsuario = await ColaboradorService.pegaColaboradoresUsuario(requisitantesIDs);
            if(requisitantesUsuario?.status != 200){
                throw requisitantesUsuario;
            }

            let requisitanteOwners = requisitantesUsuario?.data;

            //==================================================================//
            //========================== PREPARA OWNERS ========================//
            //==================================================================//

            let ordemDePagamentoOwners = UtilArray.unique([ADMIN_OWNER,emitenteOwner,...requisitanteOwners]);

            //==================================================================//
            //===================== ALTERA ORDEM DE PAGAMENTO ==================//
            //==================================================================//

            ordemDePagamentoValores = {
                id: ordemDePagamentoValores?.id || "",
                status: "Aguardando Requisitante",
                aprovadores: aprovadoresIDs || [],
                owners: ordemDePagamentoOwners || []
            }

            ordemDePagamento = await ERP.patchOne(Schema.ORDEM_DE_PAGAMENTO, ordemDePagamentoValores);
            if(ordemDePagamento.status != 200){
                throw ordemDePagamento;
            }

            console.log(ordemDePagamento);

        }catch(e){

            console.log(e);
            return ordemDePagamento;

        }

        return ordemDePagamento;

    },

}